import { render } from "./FormRadio.vue?vue&type=template&id=56a52b25&scoped=true"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"

import "./FormRadio.vue?vue&type=style&index=0&id=56a52b25&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a52b25"]])

export default __exports__